import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/features/auth/stores/authStore";

export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    // Volta para a rota originalmente pedida (preservada no state) — não força
    // /dashboard, para não perder o deep-link após login/refresh (bug #19).
    const from = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;
    return <Navigate to={from ?? "/dashboard"} replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-sidebar-grad p-4">
      <div aria-hidden className="absolute inset-0 bg-argon-mesh opacity-25" />
      <div className="relative w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
